// extracted by mini-css-extract-plugin
export default {"container":"InvitationsContent_container__h116Z","action":"InvitationsContent_action__oyHwc","actionText":"InvitationsContent_actionText__dRU-4"};